import api from './api';

// Properties a landlord has made discoverable in-app (the same apply-link a landlord can otherwise
// only share directly) — see backend ListingController.
export default {
  getListings: async () => (await api.get('/listings')).data,
  apply: async (token) => (await api.post(`/listings/${token}/apply`)).data,
};
